// Course/CourseDetail.tsx

import React from 'react';
import CourseLesson from './CourseLesson';
import {Accordion, AccordionDetails, AccordionSummary, Typography,} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {useTheme} from 'Theme/ThemeContext';
import Button from 'Core/components/elements/Button/Button';
import {ICourse} from '../../Types/psychology/course';
import {FC, FR} from "WideLayout/Layouts";
import {useNavigate} from 'react-router-dom';

interface CourseDetailProps {
    course: ICourse;
    cls?: string;
}

const CourseDetail: React.FC<CourseDetailProps> = ({course, cls}) => {
    const {plt} = useTheme();
    const navigate = useNavigate();

    const price = course.prices[1]?.amount || 0;
    const currency = course.prices[1]?.currency || '';
    const handleBuy = () => {
        navigate(`/order/course/${course.id}`, {state: {product: course}});
    };

    return (
        <FC cls={`course-detail ${cls}`} g={1} maxW={700}>
            {course.picture && (
                <img
                    src={course.picture}
                    alt={course.name}
                    className="h-100 maxh-200px object-fit-cover"
                />
            )}
            <Typography component="h2" fontSize="2rem">
                {course.name}
            </Typography>
            <FR sx={{whiteSpace: 'pre-wrap'}} color={plt.text.primary50}>
                {course.description}
            </FR>
            <FC>
                {course.lessons && course.lessons.length > 0 ? (
                    course.lessons.map((lesson) => (
                        <Accordion key={lesson.id} disabled={false}>
                            <AccordionSummary
                                className="m-0"
                                expandIcon={<ExpandMoreIcon/>}
                                aria-controls={`panel${lesson.id}-content`}
                                id={`panel${lesson.id}-header`}
                            >
                                <Typography
                                    component="h2"
                                    color={plt.text.primary60}
                                    fontSize="1.2rem"
                                >
                                    {lesson.name}
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails className="pt-0">
                                <CourseLesson lesson={lesson} isPublic={course.is_public}/>
                            </AccordionDetails>
                        </Accordion>
                    ))
                ) : (
                    <div>В этом курсы пока что нет уроков</div>
                )}
            </FC>
            {/*{!course.accessed && !course.is_public &&*/}
            {/*    <span>Цена: {Number(price)} {currency}</span>*/}
            {/*}*/}

            {!course.accessed && !course.is_public &&
                <Button className={'mt-2 maxw-300px'} variant={'contained'} color={'primary'}
                        onClick={handleBuy}>
                    Купить
                </Button>
            }
        </FC>
    );
};

export default CourseDetail;
